module.exports = __webpack_public_path__ + "static/media/screen2.c3372f03.png";